import {
  // eslint-disable-next-line no-unused-vars
  h,
  Component,
  render,
  createRef,
  Fragment,
} from 'preact';
import axios, { CancelToken } from 'axios';

import ResultList from './search/ResultList';

class ResourceCentreModule extends Component {
  state = {
    query: '',
    filter: [],
    documentFilter: [],
    page: 1,
    maxPages: 1,
    entries: [],
    count: [],
    loading: false,
    filterLoading: false,
    paginating: false,
  };

  constructor(props) {
    super(props);

    this.cancelToken = () => {};
    this.inputRef = createRef();
    this.runSearchQuery();
  }

  handleInputChange = (event) => {
    this.setState(
      {
        page: 1,
        query: event.target.value,
        filter: [],
        documentFilter: [],
        maxPages: 1,
        loading: true,
        entries: [],
        count: [],
      },
      this.runSearchQuery,
    );
  };

  runSearchQuery = async () => {
    const { query, page, filter, documentFilter, count } = this.state;

    try {
      this.cancelToken();

      let filterQuery = '';
      if (filter.length > 0) {
        filterQuery = `&subtype=${filter}`;
      }

      let documentFilterQuery = '';
      if (documentFilter.length > 0) {
        documentFilterQuery = `&document-type=${documentFilter}`;
      }

      const searchResponse = await axios.get(
        `/wp-json/deepsea/v1/resource-centre?page=${page}&per_page=100&s=${query}${filterQuery}${documentFilterQuery}`,
        {
          cancelToken: new CancelToken((c) => {
            this.cancelToken = c;
          }),
        },
      );

      if (!Array.isArray(searchResponse.data.posts) || !searchResponse.data.posts.length) {
        this.setState({
          entries: false,
          maxPages: 0,
          loading: false,
          filterLoading: false,
          paginating: false,
        });
        return;
      }

      const types = searchResponse.data.post_types;
      delete types.attachment;
      delete types.wp_block;
      delete types.nav_menu_item;
      delete types.wp_navigation;
      delete types.wp_template;
      delete types.wp_template_part;
      delete types.wp_font_face;
      delete types.wp_font_family;
      delete types.wp_global_styles;
      // Deepsea Post Types
      delete types.pages;

      const documents = searchResponse.data.document_types;

      this.setState({
        entries: searchResponse.data.posts,
        maxPages: searchResponse.data.total_pages,
        loading: false,
        filterLoading: false,
        paginating: false,
        types,
        documents,
        count: filterQuery === '' ? searchResponse.data.post_types_count : count,
      });
    } catch (e) {
      if (!axios.isCancel(e)) {
        this.setState({
          loading: false,
          filterLoading: false,
          paginating: false,
        });
      }
    }
  };

  setFilter = (newFilter) => (event) => {
    const { filter } = this.state;

    if (event.target.checked) {
      filter.push(newFilter);
    } else {
      const index = filter.indexOf(newFilter);
      if (index > -1) {
        filter.splice(index, 1);
      }
    }

    this.setState(
      {
        filter,
        filterLoading: true,
        page: 1,
      },
      this.runSearchQuery,
    );
  };

  setDocument = (newDocumentFilter) => (event) => {
    const { documentFilter } = this.state;

    if (event.target.checked) {
      documentFilter.push(newDocumentFilter);
    } else {
      const index = documentFilter.indexOf(newDocumentFilter);
      if (index > -1) {
        documentFilter.splice(index, 1);
      }
    }

    this.setState(
      {
        documentFilter,
        filterLoading: true,
        page: 1,
      },
      this.runSearchQuery,
    );
  };

  loadPage = (props) => {
    const { loading, paginating } = this.state;

    if (paginating || loading) {
      return;
    }

    this.setState(
      {
        page: parseInt(props.target.innerText, 10),
        paginating: true,
      },
      this.runSearchQuery,
    );
  };

  PageNumbers = () => {
    const { maxPages, page } = this.state;
    const pages = [];
    for (let i = 1; i <= maxPages; i += 1) {
      if (i === page) {
        pages.push(<span className="page-numbers current">{i}</span>);
      } else if (
        (i < page + 3 && i > page) ||
        (i > page - 3 && i < page) ||
        i === 1 ||
        i === maxPages
      ) {
        pages.push(
          <button onClick={this.loadPage} className="page-numbers" tabIndex="0" type="button">
            {i}
          </button>,
        );
      } else if (i === page + 3 || i === page - 3) {
        pages.push(
          <button className="page-numbers" tabIndex="0" type="button" disabled>
            ...
          </button>,
        );
      }
    }

    return <div className="pagination">{pages}</div>;
  };

  render() {
    const {
      filter,
      query,
      entries,
      page,
      paginating,
      maxPages,
      loading,
      filterLoading,
      documents,
      documentFilter,
    } = this.state;

    if (documents && entries) {
      documents.forEach((doc) => {
        // eslint-disable-next-line no-param-reassign
        doc.posts = [];
        entries.forEach((entry) => {
          if (doc.slug === entry.document_type[0].slug) {
            doc.posts.push(entry);
          }
        });
      });
    }

    return (
      <Fragment>
        {documents &&
          entries(
            <section className="section">
              <div className="section-wrapper">
                <div className="wp-block-deepsea-column col-desk-4 col-tab-4 col-mob-12 column--no-padding">
                  <h3>Documents, enquiry forms and publications </h3>
                  <div className="resource-centre--form deepsea-form">
                    <label for="resource-centre-search">Search for resources</label>
                    <div className="input-css-search">
                      <input
                        ref={this.inputRef}
                        type="text"
                        onInput={this.handleInputChange}
                        value={query}
                        placeholder="Search..."
                        onKeyDown={this.handleKeyDown}
                        name="resource-centre-search"
                      />
                      <i className="search-submit"></i>
                    </div>
                  </div>
                  <div className="resource-centre-filters">
                    <h4>Filter by type</h4>
                    <div className="search-modal-results-filters deepsea-form">
                      {Object.keys(documents).map((key) => (
                        <label
                          className="label-checkbox"
                          htmlFor={`post-type-${documents[key].slug}`}
                        >
                          <input
                            checked={documentFilter.includes(documents[key].slug)}
                            onClick={this.setDocument(documents[key].slug)}
                            type="checkbox"
                            id={`post-type-${documents[key].slug}`}
                            name="document-type"
                            value={documents[key].slug}
                            disabled={filter.length !== 0 && !filter.includes('post')}
                          />
                          <span
                            className={
                              filter.length !== 0 &&
                              !filter.includes('post') &&
                              'label-checkbox--disabled'
                            }
                          >
                            <p>{documents[key].name}</p>
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>,
          )}

        {documents &&
          entries(
            <section className="section">
              <div className="section-wrapper">
                <div className="wp-block-deepsea-column col-desk-12 col-tab-12 col-mob-12 column--no-padding">
                  {Object.keys(documents).map(
                    (key) =>
                      !filterLoading &&
                      query === '' &&
                      !paginating &&
                      entries.length > 0 &&
                      documents[key].posts.length > 0 && (
                        <Fragment>
                          <div className="document-title">
                            <h3>{documents[key].name}</h3>
                            {key === '0' && (
                              <div className="button-wrapper">
                                <a
                                  className="btn btn--line icon-download"
                                  href={window.resourcesDownloadUrl}
                                  download
                                >
                                  Download All
                                </a>
                              </div>
                            )}
                          </div>
                          <div className="post-list">
                            <ResultList entries={documents[key].posts} />
                          </div>
                        </Fragment>
                      ),
                  )}
                  <h3>{query !== '' && <span>{`Search results for '${query}'`}</span>}</h3>
                  {!filterLoading && !paginating && query !== '' && entries && (
                    <div className="post-list">
                      <ResultList entries={entries} />
                    </div>
                  )}
                  {maxPages >= page &&
                    maxPages > 1 &&
                    !filterLoading &&
                    !paginating &&
                    entries !== false && <div className="grid-footer"></div>}
                  {(filterLoading || paginating || loading) && (
                    <p className="deepsea-loader deepsea-loader--small deepsea-loader--white">
                      <span className="deepsea-spinner">Loading...</span>
                      Please wait
                    </p>
                  )}
                  {!filterLoading && !paginating && !loading && !entries.length > 0 && (
                    <p>No results found</p>
                  )}
                </div>
              </div>
            </section>,
          )}
      </Fragment>
    );
  }
}

const resourceCentre = document.getElementById('resource-centre');
if (resourceCentre !== null) {
  render(<ResourceCentreModule />, document.getElementById('resource-centre'));
}
